export const CampaignSearchKeys = {
  searchName: 'searchName'
};
